export const getPartnersLabel = (organization, type = "plural") => {
  const labels = organization?.labels?.partners || {
    singular: "Partner",
    plural: "Partners",
  };

  return labels[type];
};
